var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.499 10.9995C13.7875 10.9997 14.832 12.0449 14.832 13.3335C14.8319 14.6219 13.7874 15.6663 12.499 15.6665C11.2105 15.6665 10.1652 14.622 10.165 13.3335C10.165 12.0448 11.2104 10.9995 12.499 10.9995Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.3333C18.5 13.3333 17.8333 8 12.5 8C7.16667 8 6.5 13.3333 6.5 13.3333",
    stroke: "#333333",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/View Icon.d48bfe3cc2704cc416b005745881385d.svg";
export { ForwardRef as ReactComponent };